<template>
  <el-dialog
    title="操作日志"
    :close-on-click-modal="false"
    top="150px"
    append-to-body
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="table-wrap">
      <avue-crud
        :option="options"
        :data="deviceLog"
        ref="crud"
        :page.sync="page"
        @refresh-change="getList"
        @on-load="getList"
          >
      </avue-crud>
    </div>
  </el-dialog>
</template>
<script>
import { deviceLog } from "@/api/security/riskDevices.js";
export default {
  props: {
    id: String
  },
  data() {
    return {
      deviceLog: [], // 操作日志
      listLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100,
      },
      options: {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        height: "auto",
        calcHeight: 80,
        index: true,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        selection: true,
        menu:false,
        column: [
          {
            label: "渠道+设备UID",
            prop: "uid",
            width: 250,
            formatter: (val) => {
              return val.appid ? `(${val.appid}) ${val.uid}` : '-'
            }
          },
          {
            label: "MAC地址",
            prop: "mac",
            width: 200,
            align: "center",
          },
          {
            label: "AndroidID",
            prop: "androidId",
            width: 200,
            align: "center",
          },
          {
            label: "IDFA",
            prop: "idfa",
            width: 200,
            align: "center",
          },
          {
            label: "手机号",
            prop: "phone",
            width: 200,
            align: "center",
            display: false
          },
          {
            label: "风险等级",
            prop: "level",
            width: 200,
            align: "center",
            // 0-无风险 1-低风险 2-中风险 3-高风险
            dictData: [
              { label: "无风险", value: 0 },
              { label: "低风险", value: 1 },
              { label: "中风险", value: 2 },
              { label: "高风险", value: 3 }
            ]
          },
          {
            label: "执行策略",
            prop: "esName",
            width: 200,
            align: "left",
          },
          {
            label: "录入方式",
            prop: "enterType",
            width: 200,
            align: "center",
            display: false,
            formatter: (val) => {
              return val.enterType == 1 ? '自动录入' : '手动录入'
            }
          },
          {
            label: "录入时间",
            prop: "createTime",
            width: 200,
            align: "center",
            display: false
          },
          {
            label: "更新时间",
            prop: "updateTime",
            width: 200,
            align: "center",
            display: false
          },
          {
            label: "操作人",
            prop: "updateBy",
            width: 200,
            align: "center",
            display: false
          },
          {
            label: "备注说明",
            prop: "remark",
            width: 200,
            align: "left",
          }
        ]
      }
    };
  },
  watch: {
    "$attrs.visible"(nVal) {
      if (nVal) {
        this.getList()
      }else {
        this.deviceLog = []
        this.page.currentPage = 1
      }
    }
  },
  methods: {
    getList() {
      // 获取日志列表
      const query = {
        deviceId: this.id,
        current: this.page.currentPage,
        size: this.page.pageSize
      }
      deviceLog(query).then(res => {
        const { data, code, msg } = res.data
        if (code === 200) {
          this.deviceLog = data.records;
          this.page.total = data.total;
        } else {
          this.$message.error(msg)
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-card__header {
  background: #f5f7fa;
}
.info {
  color: #333;
}
.table-wrap {
  min-height: 500px;
}
</style>
